import { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { BarLoader, ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
// import Lightbox from "yet-another-react-lightbox-lite";
// import "yet-another-react-lightbox-lite/styles.css";
import { TostMessageContext } from "../context/TostMessage";

export function CharterNote({ showModal, setShowModal, submitRequest, jet }) {
    const [pageLoading, setPageLoading] = useState(false);
    const [cookies, ] = useCookies();
    const [formFields, setFormFields] = useState({});
    const {setTostMessage} = useContext(TostMessageContext);
    const [note, setNote] = useState("");

    useEffect(() => {
        // getData();
    }, [])

    useEffect(() => {
        if (pageLoading) return;

    }, [pageLoading]);


  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-7 min-h-[100px] w-[85%] lg:w-[35%] mx-auto my-auto bg-[#2E281F] rounded-[15px] animate-scaleIn'>
                <div onClick={() => setShowModal(false)} className='px-[5%] w-auto self-end flex justify-end text-underline text-[#ff0000] cursor-pointer'>Close</div>
                <a className='text-white text-[20px] font-bold'>{'Get Charter Quote'}</a>
                
                <div className="w-[80%] mx-auto flex flex-col mt-3 text-white">
                    <label>Add a Note (Optional)</label>
                    <textarea
                    className="my-3 bg-[transparent] text-white/70 w-full mx-auto border border-[#d8b05a]/30 rounded-lg p-3 h-28 outline-none focus:border-[#d8b05a]"
                    placeholder={`Add a comment with your request`}
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    />
                </div>

                <div className='w-[80%] mx-auto mt-3'>
                    <button onClick={() => submitRequest(jet, note)} className={`w-full flex-1 bg-[#d8b05a] text-white py-3 rounded-full`}>
                        <span className="font-bold text-black">Get Quote</span>
                    </button>
                </div>
            </div>
        </div>
    )
}
